<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<h2 class="fm-title">Acknowledgements</h2>
<p class="noindent">As with all published works, authors depend on many people for assistance. A big thanks goes to fellow author Hans Halberstadt for allowing me to use material and images from his early 1990s books on Soviet combat aircraft. Oleg Sapunkov took the time to provide the author with his research findings on the Soviet opinions of many aircraft mentioned in the book. The majority of photographs in this work come from the talented photographers of the Dreamstime stock photo agency. Rounding out those images is a selection of others from Wikimedia Commons plus Department of Defense (DOD) photographs.</p>
<p class="center">* * *</p>
<h3 class="h3">Notes to the Reader</h3>
<p class="num_list"><span class="num_hang">1.</span> Due to the book’s size and format, this work is only a broad overview of a large and complicated subject. With a few exceptions, the book focuses on aircraft and helicopters that entered series production. All weight statistics in the book are in American short tons (2,000lb per ton) in contrast to long tons/ imperial tons (2,240lb tons).</p>
<p class="num_list"><span class="num_hang">2.</span> References to performance, weights, payload, units produced, etc. presented in the book may differ from those in other sources due to timing and the secrecy practised by both sides.</p>
<p class="num_list"><span class="num_hang">3.</span> Declassified American military and civilian intelligence reports and translated Soviet articles appearing in the chapter text can be found on a number of internet websites. These include the following:</p>
<div class="blockquote">
<p class="num-alpha"><span class="num-alpha1">a.</span> Freedom of Information Act (FOIA) Electronic Reading Room</p>
<p class="num-alpha"><span class="num-alpha1">b.</span> The Center for the Study of Intelligence</p>
<p class="num-alpha"><span class="num-alpha1">c.</span> Internet Archive Search</p>
<p class="num-alpha"><span class="num-alpha1">d.</span> Defense Technical Information Archives.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Acknowledgements.vue?33b25095